/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
import locale from './locale'
import Form from 'components/Form';
import isEmpty from 'lodash/isEmpty';

const DEFAULT_REGION_CODE = 'ca';

class ModalContent extends React.Component {

  constructor(props){
    super(props)

    let phoneParsed
    if(props.mode === 'create'){
      phoneParsed = {country_code: '1', national_number: '' , region_code: DEFAULT_REGION_CODE}
    } else if (props.mode === 'update'){
      phoneParsed = isEmpty(props.data.stPhone_parsed) ? {country_code: '1', national_number: '' , region_code: DEFAULT_REGION_CODE} : props.data.stPhone_parsed
    }

    this.state = {
      formData: props.data ? {...props.data, phoneParsed: phoneParsed} : {phoneParsed: {country_code: '1', national_number: '', region_code: DEFAULT_REGION_CODE}}
    }

    this.onChange = this.onChange.bind(this)
  }

  onChange(formData) {
    this.setState({
      formData:{
        ...this.state.formData,
        ...formData
      }
    }, () => {
      this.props.onFormChange(formData)
    })
  }

  render() {
    const {formData} = this.state;
    const schema = [
      {
        name: 'tName',
        label: __('Teacher Name', locale),
        type: 'text',
        required: true,
      },
      {
        name: 'tGender',
        label: __('Gender', locale),
        type: 'gender',
        required: true,
      },
      {
        name: 'tEmail',
        label: __('Email', locale),
        type: 'text',
        required: false,
      },
      {
        name: 'profile_photo',
        label: __('Teacher Photo', locale),
        type: 'imageUploader',
        options: {
          aspectRatioHeight: 1,
          aspectRatioWidth: 1,
        }
      },
      {
        name: 'phoneParsed',
        label: __('Phone Number', locale),
        type: 'phone',
        required: false,
        tip: __("Enter a phone number to invite the teacher to download the ClassTopBase mobile App. The teacher could then change the attendance, as well as sending and receiving announcements and schedules. You could change teacher's permissions inside the permissions settings", locale)
      },

    ];

    return (
      <div className='create-teacher-modal-content'>
        <Form
          onChange={this.onChange}
          schema={schema}
          formData={formData}
          formStyle='outline'
          getValidationRef={this.props.getValidationRef}
        />
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/CreateTeacher/ModalContent.js